export function filterByString(string: string, arr) {
  return arr.filter((s) => {
    return s.name.includes(string)
  })
}
